import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';

// import { ApplicationInsights } from '@microsoft/applicationinsights-web';
// import {AngularPlugin} from '@microsoft/applicationinsights-angularplugin-js';

import { environment } from '@bo-env/environment';
import { Logger } from '@bo-client/core';
import { TenantService } from '@bo-client/core/api/api';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private tenantService: TenantService
  ) {
    // var angularPlugin = new AngularPlugin();
    // const appInsights = new ApplicationInsights({
    //   config: {
    //     instrumentationKey: '3dd8cbfb-20c8-4f43-87e3-5d6fbd4c2ebe',
    //     disableCookiesUsage: true,
    //     extensions: [angularPlugin],
    //     extensionConfig: {
    //       [angularPlugin.identifier]: {router: this.router}
    //     }
    //   }
    // });
    // appInsights.loadAppInsights();
  }

  ngOnInit() {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    // Setup translations

    const onNavigationEnd = this.router.events.pipe(filter((event) => event instanceof NavigationEnd));
  }
}
